export default {
    filter(number, decimals){
        return number.toFixed(decimals)
    }
}